/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export * from './generic-link-component.service';
export * from './generic-link.component';
export * from './generic-link.module';
